module.exports = __webpack_public_path__ + "img/paysafecard.c46d69d2.svg";